import script from "./IDEViewerContentTypeUnknown.vue?vue&type=script&lang=ts&setup=true"
export * from "./IDEViewerContentTypeUnknown.vue?vue&type=script&lang=ts&setup=true"

import "./IDEViewerContentTypeUnknown.vue?vue&type=style&index=0&id=cb2760ee&scoped=true&lang=less"

import exportComponent from "/home/gibo/development/primakurzyonline.cz-screencast/trunk/lector-code/pko-lector-code-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb2760ee"]])

export default __exports__